import { FC } from "react";
import { SelectChips } from "src/components";
import { useTranslation } from "react-i18next";
import {
  NationalitySelect,
  LocationSearch,
  SearchSubmit,
  CheckInComponent,
  CheckOutComponent,
  GuestSelection,
} from "../../HotelSearchForm";

const SearchWebLayout: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-wrap items-center gap-4">
      <div className="flex w-full flex-wrap items-center justify-between gap-4">
        <div className="font-semibold">{t("Hotels.search.searchHotels")}</div>
        <SelectChips
          rounded="md"
          classNames={{
            item: "hover:border-background-primary! border-border-default",
          }}
        >
          <NationalitySelect errorFields={errorFields} />
          <GuestSelection />
        </SelectChips>
      </div>
      <div className="border-border-default bg-background-default flex min-w-full grow flex-wrap gap-2 rounded-md border p-2">
        <LocationSearch errorFields={errorFields} />
        <div className="bg-border-subtle w-px self-stretch" />
        <CheckInComponent errorFields={errorFields} />
        <CheckOutComponent errorFields={errorFields} />
        <div className="bg-border-subtle w-px self-stretch" />
        <SearchSubmit />
      </div>
    </div>
  );
};

export default SearchWebLayout;
